import { SelectOption } from 'components/common/SelectComponent';
import {
  CommitteeCycleModel,
  StandardsBallotLineItemModel,
  StandardsBallotsVoteModel,
} from 'store/types/StandardsBallot';

export const committeeCyclesToCycleSelectOptions = (committeeCycles: CommitteeCycleModel[] | null): SelectOption[] => {
  const emptyOption: SelectOption = { name: '', value: '' };

  if (!committeeCycles) {
    return [emptyOption];
  }

  const uniqueCycles = Array.from(new Set(committeeCycles.map((c: CommitteeCycleModel): string => c.period)));

  return [
    emptyOption,
    ...uniqueCycles.map((cycle: string): SelectOption => {
      return { name: cycle, value: cycle };
    }),
  ];
};

export const committeeCyclesToCommitteeSelectOptions = (
  committeeCycles: CommitteeCycleModel[] | null
): SelectOption[] => {
  const emptyOption: SelectOption = { name: '', value: '' };

  if (!committeeCycles) {
    return [emptyOption];
  }

  const uniqueCommittees = Array.from(new Set(committeeCycles.map((c: CommitteeCycleModel): string => c.committee)));

  return [
    emptyOption,
    ...uniqueCommittees.map((committee: string): SelectOption => {
      return { name: committee, value: committee };
    }),
  ];
};

export const findLineItemVote = (
  lineItem: StandardsBallotLineItemModel,
  votes: StandardsBallotsVoteModel[]
): StandardsBallotsVoteModel => {
  const existingVote = votes.find(
    (v: StandardsBallotsVoteModel): boolean =>
      v.ballotInternalId === lineItem.ballotInternalId && v.lineItemInternalId === lineItem.lineItemInternalId
  );

  return existingVote
    ? existingVote
    : {
        standardVoteId: '-1',
        ballotInternalId: lineItem.ballotInternalId,
        lineItemInternalId: lineItem.lineItemInternalId,
        ballotTypeId: lineItem.ballotTypeId,
        vote: lineItem.ballotTypeId === '1' ? 'Accept' : 'Approve',
      };
};
